import axios from "axios"
import moment from "moment"
export const arrayToObject = (array, keyField) =>
	array.reduce((obj, item) => {
		obj[item[keyField]] = item
		return obj
	}, {})

export const objectToArray = (obj) => Object.keys(obj).map((i) => obj[i])

export const removeProperty = (obj, property) => {
	return Object.keys(obj).reduce((acc, key) => {
		if (key !== property) {
			return { ...acc, [key]: obj[key] }
		}
		return acc
	}, {})
}

export const stringToBoolean = (string) => {
	if (string == null || string === "") return false

	switch (string.toLowerCase().trim()) {
		case "true":
		case "yes":
		case "1":
			return true
		case "false":
		case "no":
		case "0":
		case null:
			return false
		default:
			return Boolean(string)
	}
}

export const formatAntiFraudDate = (date) =>
	moment(date).format("YYYY-MM-DDTHH:mm:ss.SSSZZ")

export const getClientIp = async () => {
	const res = await axios.get("https://api.ipify.org/?format=json")
	return res.data.ip
}

export const getDevicePayload = () => {
	var start = performance.now()
	var DATA_COLLECTOR_URL =
		"https://test.accdab.net/cdn/cs/HTaDglrHo2DGgUSh-84xHRxM5H4.js"
	// Data Collector script
	var s = document.createElement("script")
	s.setAttribute("type", "text/javascript")
	s.setAttribute("src", DATA_COLLECTOR_URL)
	s.setAttribute("dvct", "500")
	s.setAttribute("sid", "test-session") // set this if you have it -- UNIQUE per HTTP session if possible!
	s.setAttribute("id", "bcn")
	s.setAttribute("dvc", "l")
	s.onload = function() {
		start = performance.now()
		if (window.hasOwnProperty("_bcn") && window._bcn.hasOwnProperty("dvc")) {
			window._bcn.dvc.collect()
		}
	}
	document.head.appendChild(s)
}

export const wait = (ms) => {
	return new Promise((resolve) => setTimeout(resolve, ms))
}



// WEBPACK FOOTER //
// ./src/helpers/utility.js